import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Alert, Badge, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { BsExclamationTriangleFill, BsX } from "react-icons/bs";
import { toast } from 'react-toastify';
import { apiUrls } from 'constants/apiUrls';
import { BiPlus, BiSolidChevronLeft } from "react-icons/bi";
import { customerService } from 'services/customerService';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import { commonMessage } from 'constants/commonMessage';
import { allowNumber, allowNumberDecimal } from 'utils/inputValidator';
import DatePicker from 'react-datepicker';
import { invoiceService } from 'services/invoiceService';
import ProgressLoader from 'components/Loader/ProgressLoader';
import { ddMMyyyy } from 'utils/dateFormatter';

const CustomerInvoiceForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [message, setMessage] = useState();
    const [customer, setCustomer] = useState();
    const [invoice, setInvoice] = useState({
        customerId: id,
        invoiceNo: '',
        invoiceDate: new Date(),
        prevBalance: 0,
        gstPerc: 0,
        invoiceItems: []
    });

    useEffect(() => {
        if (id > 0) {
            setIsLoader(true);
            customerService.getCustomerDetails(apiUrls.getCustomerDetails(id)).then((res) => {
                setIsLoader(false);
                setCustomer(res);
                setInvoice({ ...invoice, customerId: res.id, invoiceNo: '', invoiceDate: null });
            }).catch((err) => setIsLoader(false));
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name == "prevBalance" && !allowNumberDecimal(e.target.value)) { return; }
        if (name == "gstPerc" && !allowNumber(e.target.value)) { return; }

        setInvoice((preValue) => ({
            ...preValue, [name]: (type == 'checkbox' ? checked : value)
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            setIsLoader(true);
            invoiceService.addInvoice(apiUrls.addInvoice(), invoice).then((res) => {
                setIsLoader(false);
                if (res > 0) {
                    toast.info("Invoice created successfully!");
                    navigate(appRoutesUrls.invoicedetails(res));
                } else {
                    setIsLoader(false);
                    toast.error(commonMessage.somethingWrong());
                }
            }).catch((err) => setIsLoader(false));
        }
    }

    const setItemDate = (value) => {
        setInvoice((preValue) => ({
            ...preValue, "invoiceDate": value
        }));
    }

    const validateForm = () => {
        setMessage();
        if (!invoice.customerId || !invoice.invoiceDate || !invoice.customerId > 0) {
            setMessage("All star marked field required!");
            return false;
        }
        return true;
    }

    return (
        <>
            <Row className="justify-content-center">
                <Col md={12}>
                    <Card className='card-default'>
                        <Card.Body>
                            {isLoader && <ProgressLoader />}
                            <Card.Title style={{ marginBottom: '0' }}>
                                <BiSolidChevronLeft
                                    size={26}
                                    className='hand'
                                    onClick={() => navigate(appRoutesUrls.customerInvoices(id))} /> New Invoice - <b>{customer?.name}</b>
                                &nbsp;{customer && !customer?.isActive && <Badge bg="danger">Inactive</Badge>}
                            </Card.Title>
                            <Row className="row row-card-no-pd" style={{ padding: '0', marginBottom: '10px' }}>
                                <Col sm={6} md={5}>
                                    <Card className="card-stats">
                                        <Card.Body>
                                            <Row>
                                                <div className="numbers">
                                                    <p className="card-category"><b>Address</b></p>
                                                    <h5>{customer?.address}</h5>
                                                </div>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} md={2}>
                                    <Card className="card-stats">
                                        <Card.Body>
                                            <Row>
                                                <div className="numbers">
                                                    <p className="card-category"><b>Mobile</b></p>
                                                    <h5>{customer?.mobileNo}</h5>
                                                </div>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} md={3}>
                                    <Card className="card-stats">
                                        <Card.Body>
                                            <Row>
                                                <div className="numbers">
                                                    <p className="card-category"><b>Email</b></p>
                                                    <h5>{customer?.email}</h5>
                                                </div>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} md={2}>
                                    <Card className="card-stats">
                                        <Card.Body>
                                            <Row>
                                                <div className="numbers">
                                                    <p className="card-category"><b>GSTIN</b></p>
                                                    <h5>{customer?.gstIn}</h5>
                                                </div>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={2} as={Link} to={appRoutesUrls.customerInvoices(id)}>
                                    <Card className="p-3 mb-1 text-info border-0">
                                        <div class="text-center">
                                            <h4 class="mb-0"><b>{customer?.totalInvoices}</b></h4>
                                            <strong>Total Invoices</strong>
                                        </div>
                                    </Card>
                                </Col>
                                <Col md={2}>
                                    <Card className="p-3 mb-1 text-primary border-0" as={Link} to={appRoutesUrls.customerInvoices(id)}>
                                        <div class="text-center">
                                            <h4 class="mb-0"><b>{customer?.buildingInvoices}</b></h4>
                                            <strong>InProgress</strong>
                                        </div>
                                    </Card>
                                </Col>
                                <Col md={2}>
                                    <Card className="p-3 mb-1 text-success border-0" as={Link} to={appRoutesUrls.customerInvoices(id)}>
                                        <div class="text-center">
                                            <h4 class="mb-0"><b>{customer?.completedInvoices}</b></h4>
                                            <strong>Completed</strong>
                                        </div>
                                    </Card>
                                </Col>
                                <Col md={2}>
                                    <Card className="p-3 mb-1 text-success border-0" as={Link} to={appRoutesUrls.customerInvoices(id)}>
                                        <div class="text-center">
                                            <h4 class="mb-0"><b>{customer?.paidInvoices}</b></h4>
                                            <strong>Paid</strong>
                                        </div>
                                    </Card>
                                </Col>
                                <Col md={2}>
                                    <Card className="p-3 mb-1 text-warning border-0" as={Link} to={appRoutesUrls.customerInvoices(id)}>
                                        <div class="text-center">
                                            <h4 class="mb-0"><b>{customer?.partlyPaidInvoices}</b></h4>
                                            <strong>Partly Paid</strong>
                                        </div>
                                    </Card>
                                </Col>
                                <Col md={2}>
                                    <Card className="p-3 mb-1 text-danger border-0" as={Link} to={appRoutesUrls.customerInvoices(id)}>
                                        <div class="text-center">
                                            <h4 class="mb-0"><b>{customer?.unpaidInvoices}</b></h4>
                                            <strong>Unpaid</strong>
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                            <Form onSubmit={handleSubmit} noValidate>
                                <Row className="mt-3 pt-4 pb-3" style={{ boxShadow: '0px 0px 2px 2px #eee', background: '#f8f9fa' }}>
                                    {message && (
                                        <Col md={12}>
                                            <Alert variant='danger'>
                                                <BsExclamationTriangleFill /> {message}
                                            </Alert>
                                        </Col>
                                    )}
                                    <Col md={6}>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label column sm="3">Invoice Date:*</Form.Label>
                                            <Col sm="9">
                                                <DatePicker
                                                    selected={invoice.invoiceDate}
                                                    onSelect={setItemDate}
                                                    dateFormat={ddMMyyyy}
                                                    className="form-control" />
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label column sm="3">Invoice No:</Form.Label>
                                            <Col sm="9">
                                                <Form.Control
                                                    type="text"
                                                    maxLength={10}
                                                    name='invoiceNo'
                                                    value={invoice.invoiceNo}
                                                    onChange={handleChange} />
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label column sm="3">Prev Balance:</Form.Label>
                                            <Col sm="9">
                                                <Form.Control
                                                    type="text"
                                                    maxLength={10}
                                                    name='prevBalance'
                                                    value={invoice.prevBalance}
                                                    onChange={handleChange} />
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label column sm="3">GST %:</Form.Label>
                                            <Col sm="9">
                                                <Form.Control
                                                    type="text"
                                                    maxLength={2}
                                                    name='gstPerc'
                                                    value={invoice.gstPerc}
                                                    onChange={handleChange} />
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                    <Col md={12} className="mt-2 text-center">
                                        <Form.Group>
                                            <Button type="submit" variant='primary' className='mw-100' disabled={!customer?.isActive}>
                                                <BiPlus size={20} /> Create
                                            </Button>
                                            <Button type="button" variant='secondary' className='ms-3 mw-100' disabled={!customer?.isActive}
                                                onClick={() => navigate(appRoutesUrls.customerInvoices(id))}>
                                                <BsX size={20} /> Cancel
                                            </Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default CustomerInvoiceForm;